import Vue from 'vue'
import Vuex from 'vuex'
import authentication from './authentication'
import alert from './alert'
import modal from './modal'
import bot from './bot'
import user from './user'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		authentication,
		alert,
		user,
		bot,
		modal
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js